export default "__VITE_ASSET__$iLbJHBf__"